import i18n from './locale'

function success(text) {
    return {
        group: 'form',
        type: 'success',
        title: i18n.t('Success'),
        text: text ? text : i18n.t('Save done'),
    };
}
function deleteSuccess(text) {
    return {
        group: 'form',
        type: 'success',
        title: i18n.t('Success'),
        text: text ? text : i18n.t('Deleted successfully'),
    };
}

function error(text) {
    return {
        group: 'form',
        type: 'error',
        title: i18n.t('Error'),
        text: text ? i18n.t(text) : i18n.t('An error happened'),
    };
}

function deleteModal() {
  return {
    title: i18n.t('Please Confirm'),
    okVariant: 'danger',
    okTitle: i18n.t('Yes, delete'),
    cancelTitle: i18n.t('No'),
  }
}

function noticeModal(title = 'Warning') {
  return {
    title: i18n.t(title),
    okVariant: 'primary',
    okTitle: i18n.t('Close'),
    cancelTitle: null,
  }
}

function dangerConfirmModal() {
    return {
        title: i18n.t('Please Confirm'),
        okVariant: 'danger',
        okTitle: i18n.t('Yes, confirm'),
        cancelTitle: i18n.t('No'),
    }
}

function confirmModal() {
    return {
        title: i18n.t('Please Confirm'),
        okVariant: 'primary',
        okTitle: i18n.t('Confirm'),
        cancelVariant: 'outline-secondary',
        cancelTitle: i18n.t('Cancel'),
    }
}
function buyEInvoiceCreditsModal() {
    return {
        title: i18n.t('Warning'),
        okVariant: 'primary',
        okTitle: i18n.t('Go to XMarket'),
        cancelVariant: 'outline-secondary',
        cancelTitle: i18n.t('Cancel'),
    }
}

function licensePopup(license, that) {
    that.$bvModal.msgBoxConfirm(that.$t('This functionality is reserved for the XStore {license} license. Go to XMarket to find out more and upgrade your license.', {license: license.ucfirst()}), {
        title: that.$t('Upgrade to {license}', {license: license.ucfirst()}),
        okVariant: 'primary',
        okTitle: that.$t('go to XMarket').ucfirst(),
        cancelTitle: that.$t('Cancel'),
    }).then(async res => {
        if (res) {
            window.open('https://xmarket.rch.it/', '_blank');
        }
    })
}

function paidLicensePopup(that) {
    that.$bvModal.msgBoxConfirm(that.$t('This functionality is reserved for the XStore Premium or Enterprise license. Go to XMarket to find out more and upgrade your license.'), {
        title: that.$t('Upgrade to Premium or Enterprise'),
        okVariant: 'primary',
        okTitle: that.$t('go to XMarket').ucfirst(),
        cancelTitle: that.$t('Cancel'),
    }).then(async res => {
        if (res) {
            window.open('https://xmarket.rch.it/', '_blank');
        }
    })
}

export {
    success,
    deleteSuccess,
    error,
    deleteModal,
    dangerConfirmModal,
    noticeModal,
    confirmModal,
    licensePopup,
    paidLicensePopup,
    buyEInvoiceCreditsModal
};
